import { Outlet } from "react-router-dom";

import {
  SidebarInset,
  SidebarProvider,
} from "@ospra/design-system/components/sidebar";

import { AppSidebar } from "../components/appSidebar";

export function DashboardLayout() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  );
}
